import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { saveSettings, loadSettings } from "../../actions/settingActions";
import { withRouter, Redirect } from "react-router-dom";
import Loading from "../../components/Loading";
import Button from "../../components/buttons/Button";
import "../Settings.css";

class Sound extends React.Component {
  /* The currently focused ringtone */
  audio = null;

  componentDidMount() {
    this.props.loadSettings();
  }

  componentWillUnmount() {
    this.props.clearSettingsSaved();
    if (this.audio !== null) {
      this.audio.pause();
    }
  }

  onSubmit = values => {
    this.props.saveSettings(values);
  };

  playRingsignal(event) {
    if (this.audio !== null) {
      this.audio.pause();
    }

    for (var i = 0; i < this.props.ringsignals.length; i++) {
      if (this.props.ringsignals[i].value === event.target.value) {
        this.audio = new Audio(this.props.ringsignals[i].audio);
        this.audio.play();
      }
    }
  }

  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    if (!this.props.config.mode.setting_ringtone_enabled) {
      return <Redirect to={"/settings"} />;
    }

    return (
      <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
        {this.props.config.mode.setting_ringtone_enabled && (
          <div>
            <div className="form-group font-weight-bold">
              <label htmlFor="settings-ringsignal">
                {this.props.text("settings.ringsignal")}
              </label>
              <Field
                id="settings-ringsignal"
                component="select"
                className="form-control"
                name="ringsignal"
                onChange={this.playRingsignal.bind(this)}
              >
                {this.props.ringsignals.map(item => (
                  <option value={item.value} key={item.value}>
                    {item.text}
                  </option>
                ))}
              </Field>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-between">
          <div />
          <div className="float-right">
            <Button
              title=" "
              type="submit"
              icon="save"
              text={this.props.text("common.save")}
            />
            {this.props.smallScreenMode && (
              <Button
                title=" "
                to={"/settings"}
                text={this.props.text("common.cancel")}
              />
            )}
          </div>
        </div>
        <div />
      </form>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      ringsignal: state.setting.user.WEB_RINGTONE,
    },
    enableReinitialize: true,
    ringsignals: state.config.ringsignals,
    loading: state.setting.loading,
    text: state.config.text,
    config: state.config,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveSettings: values => {
      return dispatch(saveSettings(values));
    },
    loadSettings: () => {
      return dispatch(loadSettings());
    },
    clearSettingsSaved: () => {
      dispatch({ type: "SETTINGS_SAVED_RESET" });
    },
  };
};

Sound = reduxForm({
  form: "sound",
})(Sound);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sound));






// WEBPACK FOOTER //
// ./src/containers/settings/Ringtone.js